import React from 'react';

import { Skeleton } from '@material-ui/lab';

import BaseSkeleton from '../BaseSkeleton';
import Card from '../../../Card';

import { OtpCardSkeletonProps } from './OtpCardSkeleton.types';

const OtpCardSkeleton: React.FC<OtpCardSkeletonProps> = ({ className }) => {
  return (
    <Card className={`relative flex flex-column p4 ${className}`}>
      <BaseSkeleton height={30} className='mb4'/>
      <div className='flex flex-row'>
      <Skeleton variant="rect" width={35} height={40} className="mr2 br2" />
      <Skeleton variant="rect" width={35} height={40} className="mr2 br2" />
      <Skeleton variant="rect" width={35} height={40} className="mr2 br2" />
      <Skeleton variant="rect" width={35} height={40} className="mr2 br2" />
      </div>
      <div className='flex flex-row mt8'>
        <Skeleton variant='rect' height={35} className="width-50 mr4 br1" />
        <Skeleton variant='rect' height={35} className="width-50 br1"/>
      </div>
    </Card>
  );
};

export default OtpCardSkeleton;
export { OtpCardSkeletonProps };